import { render, staticRenderFns } from "./errorDialog.vue?vue&type=template&id=858b1a1e&scoped=true"
import script from "./errorDialog.vue?vue&type=script&lang=js"
export * from "./errorDialog.vue?vue&type=script&lang=js"
import style0 from "./errorDialog.vue?vue&type=style&index=0&id=858b1a1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858b1a1e",
  null
  
)

export default component.exports